import styled from 'styled-components';

import { basicSmallTextStyle } from '@dreryk/react-components';

export const StyledTreatmentDaysDescriptionText = styled.div`
   ${basicSmallTextStyle};
   margin-top: 8px;
`;
StyledTreatmentDaysDescriptionText.displayName = 'StyledTreatmentDaysDescriptionText';
